import { useState } from "react";
import { Tabs } from "../../../../components/common/Tabs";
import { useTheme } from "../../../../components/hooks/useTheme";
import { GeneralSettings } from "./GeneralSettings";
import { TextSettings } from "./TextSettings";

const tabs = [
  {
    label: "General Settings",
  },
  {
    label: "Text Settings",
  },
  {
    label: "Transaction Form",
  },
]

export const Settings = () => {
  const { themeStyles } = useTheme();
  const [state, setState] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="w-full my-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {
            activeIndex === 0 && (
              <GeneralSettings
                state={state}
                setState={(value) => setState(value)}
                zip={zip}
                setZip={(value) => setZip(value)} />
            )
          }
          {
            activeIndex === 1 && (
              <TextSettings
                state={state}
                setState={(value) => setState(value)}
                zip={zip}
                setZip={(value) => setZip(value)} />
            )
          }
        </div>
      </div>
    </div>
  )
}